
<div class="pageHeader ">
  <span
      class="text-dark fw-bolder   fs-4 flex place-items-center justify-center justify-items-center items-center">
      <!-- <img src="assets/img/school.svg" class="svg-icon svg-icon-3" style="width:30px"/>  -->
      <span class="my-auto">     {{"common.dashboard" | translate}}</span>

  
  </span>
  <div class="">
     
<nz-range-picker class="booking-date"  [nzPlaceHolder]="['التاريخ من', 'إلى']" [nzRanges]="ranges" style="width: 100%"  [(ngModel)]="todayDate"  (ngModelChange)="onChangeDate($event)">
</nz-range-picker>
  </div>
</div>




<div class="row m-4 ">
  <div class="col-md-6 col-sm-12">

    <div class="row  w-full divide-y divide-gray-300  overflow-x-auto md:rounded-lg bg-white m-2">
      <div class="col-md-12 col-sm-12 ">
        <div
        class="text-dark fw-bolder border border-gray-100 text-hover-primary fs-4 flex place-items-right justify-right justify-items-right items-right p-2">
        <!-- <img src="assets/img/school.svg" class="svg-icon svg-icon-3" style="width:30px"/>  -->
        <span class="my-auto text-right">{{"common.appointments_per_courts" | translate}}</span>


      </div>
      </div>

      <div class="col-md-12 col-sm-12 p-2">
        <div echarts [options]="option2" class="demo-chart " style="direction: ltr;"></div>
      </div>
    </div>

  </div>

  <div class="col-md-6 col-sm-12">

    <div class="row  w-full divide-y divide-gray-300  overflow-x-auto md:rounded-lg bg-white m-2">
      <div class="col-md-12 col-sm-12  p-2">
        <div
        class="text-dark fw-bolder text-hover-primary fs-4 flex place-items-right justify-right justify-items-right items-right border border-gray-100">
        <!-- <img src="assets/img/school.svg" class="svg-icon svg-icon-3" style="width:30px"/>  -->
        <span class="my-auto text-right">{{"common.appointments_per_days" | translate}}</span>


      </div>
      </div>

      <div class="col-md-12 col-sm-12  p-2 ">
        <div echarts [options]="option3" class="demo-chart " style="direction: ltr;"></div>
      </div>
    </div>

  </div>




</div>

<div class="row m-4 ">

  <div class="col-md-6 col-sm-12">

    <div class="row  w-full divide-y divide-gray-300 overflow-x-auto md:rounded-lg bg-white m-2">
      <div class="col-md-12 col-sm-12  p-2">
        <div
        class="text-dark fw-bolder text-hover-primary fs-4 flex place-items-right justify-right justify-items-right items-right border border-gray-100">
        <!-- <img src="assets/img/school.svg" class="svg-icon svg-icon-3" style="width:30px"/>  -->
        <span class="my-auto text-right"> {{"common.appointments_per_months" | translate}}</span>


      </div>
      </div>

      <div class="col-md-12 col-sm-12  p-2">
        <div echarts [options]="options" style="direction: ltr;" class="demo-chart "></div>
      </div>
    </div>

  </div>
  <div class="col-md-6 col-sm-12">

    <div class="row  w-full divide-y divide-gray-300 overflow-x-auto md:rounded-lg bg-white m-2">
      <div class="col-md-12 col-sm-12  p-2">
        <div
        class="text-dark fw-bolder text-hover-primary fs-4 flex place-items-right justify-right justify-items-right items-right border border-gray-100">
        <!-- <img src="assets/img/school.svg" class="svg-icon svg-icon-3" style="width:30px"/>  -->
        <span class="my-auto text-right">{{"common.appointments_money_per_monhts" | translate}}</span>


      </div>
      </div>

      <div class="col-md-12 col-sm-12  p-2" style="direction: ltr;">
        <div echarts [options]="optionsAppointmentsValuesByMonths" class="demo-chart "></div>
      </div>
    </div>

  </div>

</div>
